import { z } from 'zod'
import { oc } from '@orpc/contract'

export const authorizationGet = oc
  .route({ method: 'GET', path: '/v2/authorization' })
  // patientId is honored only for Practitioner (provider-portal) callers; patient
  // callers are always scoped to their own profile (IDOR guard in the handler).
  .input(z.object({ patientId: z.string().optional() }))
  .output(
    z.object({
      items: z.array(
        z.object({
          organizationId: z.string(),
          organizationName: z.string().optional(),
          status: z.string().optional(),
          granted: z.boolean(),
          // When the authorization was signed (Consent provision.period.start ?? dateTime).
          signedDate: z.string().optional(),
          // Signed authorization document (DocumentReference) once active.
          document: z.any().optional(),
          documentUrl: z.string().optional(),
        }),
      ),
    }),
  )
